// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__Uu72T","file":"UserPhotoPost_file__8UH8k","preview":"UserPhotoPost_preview__XN8Yo"};